import { FaHtml5 } from "react-icons/fa";
import { FaJsSquare } from "react-icons/fa";
import { FaCss3 } from "react-icons/fa";
import { FaPython } from "react-icons/fa";
import { FaReact } from "react-icons/fa";
import { FaNodeJs } from "react-icons/fa";
import { FaGit } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { DiDjango } from 'react-icons/di';
import { DiJavascript1 } from "react-icons/di";
import { DiMongodb } from "react-icons/di";

const technologyIcons = {
    "HTML":<FaHtml5 />,
    "Javascript": <FaJsSquare />,
    "Python": <FaPython />,
    "CSS": <FaCss3 />,
    "React": <FaReact />,
    "Django": <DiDjango />,
    "Node.js": <FaNodeJs />,
    "Express": <DiJavascript1 />,
    "MongoDB": <DiMongodb />,
    "Mongoose": <DiJavascript1 />,
    "GitHUB": <FaGithub />,
    "Git": <FaGit />
}

export default technologyIcons;